// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d9504a93","977":"b8c4bff7"}[chunkId] + ".chunk.js";
};